import { FirstClassDocument } from '../../types';
import { UNCHUNKED_DOCUMENT_CHUNK_ID, WebviewDocumentChunk } from '../../types/chunkedDocuments';
// eslint-disable-next-line import/no-cycle
import database from '../database';
import { loadChunksFromSpineAndManifest } from '../methods';
import { globalState } from '../models';
import { makeUnchunkedWebviewChunk, makeWebviewChunksFromDocumentChunks } from '../stateHooks/useChunksForDocument';
import { getSpineForDoc } from './getSpineForDoc';

export async function getAllWebviewChunksForDocId(docId: string): Promise<WebviewDocumentChunk[] | null> {
  const docTransientData = globalState.getState().transientDocumentsData[docId];
  const manifest = docTransientData.manifest;
  const spine = getSpineForDoc(docId);
  let webviewDocumentChunks: WebviewDocumentChunk[] | null = null;
  if (spine[0] === UNCHUNKED_DOCUMENT_CHUNK_ID) {
    const doc = await database.collections.documents.findOne<FirstClassDocument>(docId);
    webviewDocumentChunks = [makeUnchunkedWebviewChunk(doc?.word_count, undefined)];
  } else {
    const documentChunks = await loadChunksFromSpineAndManifest(spine, manifest, docId);
    webviewDocumentChunks = makeWebviewChunksFromDocumentChunks(documentChunks) ?? null;
  }
  return webviewDocumentChunks;
}
